import { InputText } from 'mailup-web-components'
import PropTypes from 'prop-types'
import React from 'react'
import { useIntl } from 'react-intl'

export const InputSearchString = ({
  searchText,
  handleInputChange,
  handleKeyPress
}) => {
  const intl = useIntl()

  return (
    <InputText
      placeholder={intl.formatMessage({
        id: 'Load.Common.CercaPaese'
      })}
      value={searchText}
      onChange={handleInputChange}
      onKeyPress={handleKeyPress}
      data-mu-test='table-cost-search-field__search-text'
    />
  )
}

InputSearchString.propTypes = {
  handleKeyPress: PropTypes.func,
  handleInputChange: PropTypes.func,
  searchText: PropTypes.string
}
